import { render, staticRenderFns } from "./tiaojia.vue?vue&type=template&id=4dc7ca14&scoped=true"
import script from "./tiaojia.vue?vue&type=script&lang=js"
export * from "./tiaojia.vue?vue&type=script&lang=js"
import style0 from "./tiaojia.vue?vue&type=style&index=0&id=4dc7ca14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc7ca14",
  null
  
)

export default component.exports